import Loadable from 'react-loadable';

import { LoadableLoadingSection } from 'components/LoadableLoadingSection';

export const ViewGradProgramPageLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ViewGradProgramPage" */
      './ViewGradProgramPage.dynamic'
    ),
  loading: LoadableLoadingSection,
});
